import * as React from 'react';

import {Session} from 'nutshell-core/session';
import type {ProductMap} from 'nutshell-core/types';

import styles from './editable-product-map-row.module.css';

type Props = {
    productMap: ProductMap;
    locale?: string;
    currencyCode?: string;
};

/*
Controlled component to display a productMaps name alongside quantity and amount
 */
export class ProductMapRow extends React.PureComponent<Props> {
    static defaultProps = {
        currencyCode: Session.getInstanceDefaultCurrencyCode(),
    };

    render() {
        const value = Number(this.props.productMap.price.amount).toLocaleString(this.props.locale, {
            style: 'currency',
            currency: this.props.currencyCode,
        });

        // @TODO turn me into a table and use a shared table component
        return (
            <div className={styles.container}>
                <div className={styles['product-name']}>{this.props.productMap.name}</div>
                <div className={styles['product-quantity']}>
                    {String(this.props.productMap.quantity)}
                </div>
                <div className={styles['product-price']}>{value}</div>
            </div>
        );
    }
}
